import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
// import { Ng2TelInputModule } from 'ng2-tel-input';
import { SharedModule } from '../../shared/shared.module';
import { IntlInputComponent } from './components/intl-input/intl-input.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
  ],
  declarations: [
    IntlInputComponent
  ],
  exports: [
    IntlInputComponent
  ],
  bootstrap: [
    IntlInputComponent
  ]
})
export class IntlInputModule {
  getComponent() {
    return IntlInputComponent;
  }
}
